import { Components, Theme } from '@mui/material'

import { MuiButton } from './button'
import { MuiDialog, MuiDialogActions, MuiDialogContent } from './dialog'
import { MuiLink } from './link'
import { MuiListItemButton } from './listItemButton'
import { typographyComponent } from './typography'

const components: Components<Theme> = {
  MuiButton: MuiButton,
  MuiDialog: MuiDialog,
  MuiDialogActions: MuiDialogActions,
  MuiDialogContent: MuiDialogContent,
  MuiInput: {
    defaultProps: {
      disableUnderline: true,
    },
  },
  MuiLink: MuiLink,
  MuiListItemButton: MuiListItemButton,
  MuiTypography: typographyComponent,
  MuiDrawer: {
    defaultProps: {
      transitionDuration: 0,
    },
  },
  MuiPaper: {
    defaultProps: {
      elevation: 0,
    },
  },
}

export default components
